enum SailthruList {
    EVERGREEN_LIST = 'Evergreen email capture',
    MASTER_LIST = 'Master List',
}

interface ISignUpByEmailOptions {
    email: string,
    onSuccess? (): void;
    onError? (): void;
}

export class SailthruClient {
    public static API_URL: string = window.ozShopifyApp.dataSources.sailthru.api;

    public static initialize (): void {
        const customerId: string = SailthruClient.getCustomerId();

        window.Sailthru.init({ customerId: customerId });
    }

    public static signUpByEmail (options: ISignUpByEmailOptions): Promise<undefined> {
        const { email, onSuccess, onError }: ISignUpByEmailOptions = options;

        return window.Sailthru.integration('userSignUp', {
            email: email,
            key: 'email',
            lists: {
                [SailthruList.EVERGREEN_LIST]: 1,
                [SailthruList.MASTER_LIST]: 1,
            },
            onSuccess: onSuccess,
            onError: onError,
        });
    }

    private static getCustomerId (): string | never {
        const customerId: string | undefined = window.ozShopifyApp.dataSources.sailthru.customerId;

        if (!customerId) {
            throw new Error('Missing REACT_APP_SAILTHRU_CUSTOMER_ID');
        }

        return customerId;
    }
}
